'use client'

import { useEffect } from 'react'

import { useFetch } from '@marketplace-web/core-api/api-client-util'
import {
  getSellerInsights,
  transformGetSellerInsightsResponse,
} from '@marketplace-web/seller-engagement-tools/seller-engagement-tools-data'

const useGetSellerInsights = () => {
  const {
    fetch: fetchSellerInsights,
    isLoading: isSellerInsightsLoading,
    transformedData: sellerInsights,
  } = useFetch(getSellerInsights, transformGetSellerInsightsResponse)

  useEffect(() => {
    fetchSellerInsights()
  }, [fetchSellerInsights])

  return {
    sellerInsights,
    isSellerInsightsLoading,
  }
}

export default useGetSellerInsights
